export default "__VITE_ASSET__Cbua4wrF__"